import { Component, EventListener, getComponentByDomNode } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { getCurrentViewport, VIEWPORT_ENTERED } from '@gondel/plugin-media-queries';
import { Overlay } from '@swisslife/patterns-base/src/organisms/overlay/js/overlay';
import { Header } from '../../../organisms/header/js/header';
import { setCookie } from '@swisslife/shared-ui/src/utils/cookies/js/cookies';

enum States {
	OverlayVisible = 'state-m-website-selector--overlay-visible',
	OverlayTransition = 'state-m-website-selector--overlay-transition',
}

enum Selectors {
	Header = '.js-o-header',
	Overlay = '.js-o-overlay',
	OverlayContent = '.js-m-website-selector__overlay-content',
	Link = '.js-m-website-selector__link',
	Item = '.js-m-website-selector__item',
}

// The @Component decorator will connect the class with `data-g-name="WebsiteSelector"` elements.
@Component('WebsiteSelector')
export class WebsiteSelector extends GondelJqueryComponent {
	private uxBehaviourType;
	private $header: JQuery;
	private header: Header;
	private $overlay: JQuery;
	private overlay: Overlay;

	public start() {
		this.$header = this.$ctx.closest(Selectors.Header);
		this.$overlay = this.$ctx.find(Selectors.Overlay);

		const currentVp = getCurrentViewport();
		this.updateUxBehaviourType(currentVp);

		if (this.$header.length === 0) {
			// tslint:disable-next-line
			return console.warn(`Use WebsiteSelector just within a header!`);
		} else {
			this.header = getComponentByDomNode<Header>(this.$header);
		}

		if (this.$overlay.length === 0) {
			// tslint:disable-next-line
			return console.warn(`To use login, you need to provide an overlay!`);
		} else {
			this.overlay = getComponentByDomNode<Overlay>(this.$overlay.get(0));
		}
	}

	/**
	 * Website selector item click
	 * @param ev {MouseEvent}		native event
	 */
	@EventListener('click', Selectors.Item)
	public _handleWebsiteSelectorLinkItemClick(ev: MouseEvent) {
		const $target = $(ev.currentTarget!);
		setCookie($target.data('cookie-name'), $target.data('cookie-value'));
	}

	/**
	 * Website selector click
	 * @param ev {MouseEvent}		native event
	 */
	@EventListener('click', Selectors.Link)
	public _handleWebsiteSelectorLinkClick(ev: MouseEvent) {
		ev.preventDefault();

		if (this.uxBehaviourType === 'large') {
			this.header.showMetaNavOverlay(this.overlay, true, this.$ctx.find(Selectors.OverlayContent).children());

			// close a possibly open navigation overlay
			this.header.closeNavigationOverlay(true);
		} else {
			this.toggleOverlaySmall(this.$ctx);
		}
	}

	@EventListener(VIEWPORT_ENTERED)
	public _handleViewportChangeEvent(event) {
		this.updateUxBehaviourType(event.viewport);
	}

	/**
	 * Show the overlay for uxBehaviourType small
	 * @param $entry {Object}			the entry to search for the overlay
	 */
	private toggleOverlaySmall($entry: JQuery) {
		const $overlaySmall = $entry.find(Selectors.OverlayContent);

		if (!$overlaySmall.hasClass(States.OverlayVisible)) {
			$overlaySmall.toggleClass(States.OverlayVisible);
			$overlaySmall.outerWidth(); // Reflow to make transition work
			$overlaySmall.addClass(States.OverlayTransition);
			this.header.toggleWebsiteSelector(true);
		} else {
			$overlaySmall.removeClass(States.OverlayTransition);
			this.header.toggleWebsiteSelector(false);

			$overlaySmall.one('transitionend', () => {
				$overlaySmall.removeClass(States.OverlayVisible);
			});
		}
	}

	/**
	 * Update the uxBehaviourType variable
	 * @param viewport {string}			the new viewport
	 */
	private updateUxBehaviourType(viewport: string) {
		if (viewport === 'large' || viewport === 'xlarge' || viewport === 'xxlarge') {
			this.uxBehaviourType = 'large';
		} else {
			this.uxBehaviourType = 'small';
		}
	}
}
